import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from '@core/models/can-component-deactivate.model';

/**
 * ✅ Route Guard to prevent navigation when component has unsaved changes
 * 
 * How it works:
 * 1. Angular router calls this guard before navigation
 * 2. Guard asks the component if it can deactivate
 * 3. Component shows confirmation dialog if needed
 * 4. Guard returns the result (true = allow, false = block)
 */
@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  
  /**
   * Called by Angular Router before navigating away from the component
   * 
   * @param component - The component being navigated away from
   * @param currentRoute - Current activated route
   * @param currentState - Current router state
   * @param nextState - Target router state (where user is going)
   * @returns Observable<boolean> | Promise<boolean> | boolean
   */
  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    // Log navigation attempt (helpful for debugging)
    
    // Check if component implements canDeactivate method
    if (!component.canDeactivate) {
      return true;
    }
    
    // Ask the component if it's safe to leave
    const canLeave = component.canDeactivate(currentRoute, currentState, nextState);
    
    // Log the result
    if (canLeave instanceof Observable || canLeave instanceof Promise) {
      
    } else {

    }
    
    return canLeave;
  }
}